export const LIST_EXAM_WORD_CATEGORY = 'LIST_EXAM_WORD_CATEGORY';
export const CREATE_EXAM_WORD_CATEGORY = 'CREATE_EXAM_WORD_CATEGORY';
export const SHOW_EXAM_WORD_CATEGORY = 'SHOW_EXAM_WORD_CATEGORY';
export const UPDATE_EXAM_WORD_CATEGORY = 'UPDATE_EXAM_WORD_CATEGORY';
export const DELETE_EXAM_WORD_CATEGORY = 'DELETE_EXAM_WORD_CATEGORY';
export const EXAMWORDCATEGORY_ADD_DELETE = 'EXAMWORDCATEGORY_ADD_DELETE';
export const EXAMWORDCATEGORY_CHECK_ALL = 'EXAMWORDCATEGORY_CHECK_ALL';
export const DATA_REMOVE_EXAM_WORD_CATEGORY = 'DATA_REMOVE_EXAM_WORD_CATEGORY';

export const EXAMWORDCATEGORY_SET_PART_LISTS = 'EXAMWORDCATEGORY_SET_PART_LISTS';
export const EXAMWORDCATEGORY_PART_ADD = 'EXAMWORDCATEGORY_PART_ADD';
export const EXAMWORDCATEGORY_PART_HIDE = 'EXAMWORDCATEGORY_PART_HIDE';
export const EXAMWORDCATEGORY_PART_UNHIDE = 'EXAMWORDCATEGORY_PART_UNHIDE';
export const EXAMWORDCATEGORY_PART_DELETE = 'EXAMWORDCATEGORY_PART_DELETE';
export const EXAMWORDCATEGORY_PART_RESTORE = 'EXAMWORDCATEGORY_PART_RESTORE';
export const EXAMWORDCATEGORY_PART_PURGE = 'EXAMWORDCATEGORY_PART_PURGE';
export const EXAMWORDCATEGORY_PART_RENAME = 'EXAMWORDCATEGORY_PART_RENAME';

